import { CallState } from '../../../features/call/call.types';

export const loadingCallStates = [
  CallState.Initializing,
  CallState.TestCallInitializing,
  CallState.Restarting,
  CallState.WaitingForParticipantsAfterRestart,
  CallState.WaitingForParticipants,
];

export const getIsCallLoading = (callState: CallState): boolean =>
  loadingCallStates.includes(callState);
